import React, { FunctionComponent } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { DATA_QA } from '../../../helpers/data-qa';
import '../../../styles/news-forge.styles.scss';
import { Link } from 'react-router-dom';

type ModalDeleteProps = {
	setShowModal: (show: boolean) => void;
	showModal: boolean;
	articleId: string | null;
};

export const CreatedArticleModal: FunctionComponent<ModalDeleteProps> = ({ setShowModal, showModal, articleId }) => {
	const [t] = useTranslation();

	const closeModal = () => setShowModal(false);

	return (
		<Modal data-qa={DATA_QA.NEWS_FORGE_CREATED_ARTICLE_MODAL} isOpen={showModal} className='created-article-modal'>
			<ModalHeader
				className='border-0'
				toggle={() => {
					closeModal();
				}}
			>
				<span className='created-article-modal-text-header'>{t('creation_successful')}</span>
			</ModalHeader>
			<ModalBody className='border-0'>
				<span className='created-article-modal-text'>{`${t('created_article_modal_message')}`}</span>
			</ModalBody>
			<ModalFooter className='border-0'>
				<div className='created-article-modal-btns'>
					<div className='close-btn' onClick={closeModal}>
						<span className='close-btn-text'>{t('close')}</span>
					</div>
					{articleId && (
						<Link to={`/smp/articles/edit/${articleId}`} className='go-to-article-btn'>
							<span className='go-to-article-text'>{t('go_to_article')}</span>
						</Link>
					)}
				</div>
			</ModalFooter>
		</Modal>
	);
};
